const CheckEffectIcon = () => {
    return (
        <svg
            width='23'
            height='20'
            viewBox='0 0 23 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M3.125 11.25L7.5 15.625L17.5 5.625'
                stroke='#98E9AC'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M6.125 11.25L10.5 15.625L20.5 5.625'
                stroke='#090B2A'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};

export default CheckEffectIcon;
